import SolutionChallengesI18n from "@/components/landing/shared/SolutionChallengesI18n";
import { MailWarning, Clock, HelpCircle, Layers } from "lucide-react";
const KundenserviceChallengesSection = () => <SolutionChallengesI18n translationPrefix="kundenserviceSolution" icons={[MailWarning, Clock, HelpCircle, Layers]} />;
export default KundenserviceChallengesSection;
